import script from "./keyMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./keyMetrics.vue?vue&type=script&setup=true&lang=js"

import "./keyMetrics.vue?vue&type=style&index=0&id=4147e6cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4147e6cc"]])

export default __exports__